import { render } from "./DeleteButton.vue?vue&type=template&id=4b6294a6"
import script from "./DeleteButton.vue?vue&type=script&lang=js"
export * from "./DeleteButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dmp/releases/1776447368/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__